<rt-name-symbol-input
  [placeholder]="'app.views.view_page.view_name_input_placeholder' | translate"
  [nameControl]="nameControl()"
  [symbolControl]="symbolControl()"
  [disabled]="disabled()"
  [formErrors]="errors"
  [fallbackIcon]="fallbackIcon()"
  [forceFallback]="isViewPredefined()"
/>
